/* MoRetro Studio V20 — History helpers
   Prépare une gestion propre de l'historique sans remplacer l'existant.
*/
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  function sort(history = []){
    return [...history].sort((a,b)=>new Date(b.date || 0) - new Date(a.date || 0));
  }

  function label(entry = {}){
    return entry.label || entry.title || entry.type || "Action";
  }

  function render(project = {}){
    const history = sort(project.history || []);
    if(!history.length) return `<div class="mts-empty">Aucun historique pour ce projet.</div>`;

    return `
      <div class="mts-timeline">
        ${history.map(h=>`
          <div class="mts-timeline-item">
            <span></span>
            <div>
              <strong>${MTS.escapeHtml(label(h))}</strong>
              <em>${MTS.escapeHtml(h.date ? new Date(h.date).toLocaleString("fr-FR") : "")}</em>
            </div>
          </div>
        `).join("")}
      </div>
    `;
  }

  MTS.History = { sort, label, render };
})(window.MTS);
